import { Component, Input, OnInit } from '@angular/core';
import { CalendariosBloqueoComponent } from '@app/pages/admin/calendarios/calendarios-bloqueo/calendarios-bloqueo.component';
import { NgbCalendar, NgbDate, NgbDatepickerConfig, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-range-calendar-management',
  templateUrl: './range-calendar-management.component.html',
  styleUrls: ['./range-calendar-management.component.scss']
})
export class RangeCalendarManagementComponent implements OnInit {

  @Input() festiveDays: Array<any>;
  @Input() endfestiveDays: any;
  today: Date = new Date();
  model: NgbDateStruct = {
    year: Number(this.calendar.getToday().year),
    month: Number(this.calendar.getToday().month),
    day: Number(this.calendar.getToday().day)
  }
  numberShow: number = 10;
  actualday: number = this.calendar.getToday().day;


  constructor(
    public calendar: NgbCalendar,
    public config: NgbDatepickerConfig
  ) {

  }

  ngOnInit() {

console.log(this.endfestiveDays);

    }

  ngOnChanges(){
    this.bloqueoDiaCalendario();
  }

  isToday = (date: NgbDate) => {
    return date.day === this.today.getDate() &&
      date.month === this.today.getMonth() + 1 &&
      date.year === this.today.getFullYear();
  }

  holidayType(type: string, date: any): boolean {

    if (type === 'today' && date.day === this.today.getDate() &&
    date.month === this.today.getMonth() + 1 &&
    date.year === this.today.getFullYear())
    {
      return true;
    }
    if (type === 'national' && this.festiveDays.find(day =>
      day.festiveType === 1 &&
      String(day.dateFestiveOffice) === (
        String(date.year) +
        ((date.month <= 9) ? '0' + String(date.month) : String(date.month)) +
        ((date.day <= 9) ? '0' + String(date.day) : String(date.day))
      )
    )) {
      return true;
    } else if (type === 'local' && this.festiveDays.find(day =>
      day.festiveType === 2 &&
      String(day.dateFestiveOffice) === (
        String(date.year) +
        ((date.month <= 9) ? '0' + String(date.month) : String(date.month)) +
        ((date.day <= 9) ? '0' + String(date.day) : String(date.day))
      )
    )) {
      return true;
    }
    else if (type === 'end' && String(this.endfestiveDays) === (
      String(date.year) +
      ((date.month <= 9) ? '0' + String(date.month) : String(date.month)) +
      ((date.day <= 9) ? '0' + String(date.day) : String(date.day))
    )
    ) {
      return true;

    } else if (type === 'weekend' && this.festiveDays.find(day =>
      !day.festiveType &&
      String(day.dateFestiveOffice) === (
        String(date.year) +
        ((date.month <= 9) ? '0' + String(date.month) : String(date.month)) +
        ((date.day <= 9) ? '0' + String(date.day) : String(date.day))
      )
    )) {
      return true;
    }
    return false;
  }

  festiveDescription(date) {
    if (date.month < 9 || date.month == 9) {
      var dateMonth = "0" + date.month;
    } else {
      dateMonth = date.month;
    }
    if (date.day < 9 || date.day == 9) {
      var dateDay = "0" + date.day;
    } else {
      dateDay = date.day;
    }

    var dateFestivos = date.year + "" + dateMonth + "" + dateDay;


    let description = '';
    if (this.festiveDays.length != 0) {
      for (var i = 0; i < this.festiveDays.length; i++) {
        if (this.festiveDays[i].dateFestiveOffice == dateFestivos && this.festiveDays[i].festiveDescription != null) {
          var foundFestive = this.festiveDays[i].festiveDescription;
          description = foundFestive;
          return description;
        }
      }
    }
  }

  bloqueoDiaCalendario(){
    var datef = String(this.endfestiveDays);
    var anio = datef.substring(0, 4);
    var mes = datef.substring(4, 6);
    var dia = datef.substring(6, 8);
    this.config.maxDate = { year: Number(anio), month: Number(mes), day: Number(dia) };
    //en el caso de que querrais indicar un dia minimo seria la siguiente estructura (number no admite 0 a la izquierda)
   // this.config.minDate = { year: Number(2017), month: Number(1), day: Number(1) };
  }

}

